export enum Color {
    Black = 'black',
    Blue = 'blue',
    Cyan = 'cyan',
    Dark = 'dark',
    Gray = 'gray-500',
    GrayDark = 'gray-600',
    GrayDarker = 'gray-700',
    GrayDarkest = 'gray-800',
    GrayLight = 'gray-400',
    GrayLighter = 'gray-300',
    GrayLightest = 'gray-200',
    Green = 'green',
    GreenDarker = 'green-darker',
    Indigo = 'indigo',
    Light = 'light',
    OffWhite = 'gray-100',
    Pink = 'pink',
    Purple = 'purple',
    Orange = 'orange',
    Red = 'red',
    Slate = 'slate',
    Teal = 'teal',
    Transparent = 'transparent',
    White = 'white',
    Yellow = 'yellow',

    // Design System 2 Grays.
    DarkGray = 'dark-gray',
    TextGray = 'text-gray',
    GraphicGray = 'graphic-gray',
    MidGray = 'mid-gray',
    LightGray = 'light-gray',
    BrightGray = 'bright-gray'
}
